export default __webpack_public_path__ + "static/media/img10.27604a55.png";